import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=fd4afd28&scoped=true"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"
import style0 from "./Terminals.vue?vue&type=style&index=0&id=fd4afd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4afd28",
  null
  
)

export default component.exports